import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import {IconButton, IconButtonProps, Tooltip} from '@mui/material';
import {MouseEvent} from 'react';

import {
  buildHistoryReportUrl,
  buildPanelDrilldownUrl,
  HistoryReportExtraParams,
  HistoryReportId,
} from '../../utils/historyReportUrl';
import {PanelCode} from '../../utils/panels';
import {DashboardHistoryReportType} from '../dashboard-panels/DashboardPanelItem';

type CommonProps = {
  extra?: HistoryReportExtraParams;
  size?: IconButtonProps['size'];
  tooltip?: string;
  className?: string;
  edge?: IconButtonProps['edge'];
};

type HistoryTypeProps = CommonProps & {
  type: DashboardHistoryReportType;
  id: HistoryReportId;
  panelCode?: never;
};

type PanelCodeProps = CommonProps & {
  panelCode: PanelCode;
  type?: never;
  id?: never;
};

type Props = HistoryTypeProps | PanelCodeProps;

const OpenHistoryInNewTabButton = ({
  type,
  id,
  panelCode,
  extra,
  size = 'small',
  tooltip = 'Open in new tab',
  className,
  edge,
}: Props) => {
  const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    event.preventDefault();
    const url =
      type !== undefined && id !== undefined
        ? buildHistoryReportUrl(type, id, extra)
        : panelCode
          ? buildPanelDrilldownUrl(panelCode, extra)
          : null;
    if (!url || url === '#') {
      return;
    }
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  return (
    <Tooltip title={tooltip}>
      <IconButton
        size={size}
        edge={edge}
        className={className}
        onClick={handleClick}
        aria-label={tooltip}
      >
        <OpenInNewIcon fontSize="inherit" />
      </IconButton>
    </Tooltip>
  );
};

export default OpenHistoryInNewTabButton;
